import { useParams } from "react-router-dom";
import { useSource } from "../api/source";

import {
  Box,
  CircularProgress,
  Container,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { SPACING } from "../../common/constants/spacing";
import { SourceAssetsTab } from "../components/SourceAssetsTab";
import { SourceDetailsTab } from "../components/SourceDetailsTab";
import { SourceHeader } from "../components/SourceHeader";
import { SourceSettingsTab } from "../components/SourceSettingsTab";

export const Source = () => {
  const { sourceId } = useParams();
  const { source, loading, deleteSource, updateSource, updating } =
    useSource(sourceId);
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (loading) {
    return (
      <Container sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Container>
    );
  }

  if (!source && !loading) {
    return (
      <Container>
        <Typography
          variant="h6"
          sx={{ mb: SPACING.sm, fontWeight: 600 }}
          color="error"
        >
          Source not found
        </Typography>
      </Container>
    );
  }

  return (
    <Box>
      <SourceHeader source={source} />
      <Box sx={{ mb: 4 }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="Details" />
            <Tab label="Assets" />
            <Tab label="Settings" />
          </Tabs>
        </Box>
        {activeTab === 0 && <SourceDetailsTab source={source} />}
        {activeTab === 1 && <SourceAssetsTab source={source} />}
        {activeTab === 2 && (
          <SourceSettingsTab
            source={source}
            deleteSource={deleteSource}
            updateSource={updateSource}
            updating={updating}
          />
        )}
      </Box>
    </Box>
  );
};
